var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomepageFeatureInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155,
    height: 120,
    viewBox: "0 0 155 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tablet with dollar symbol on the screen and a phone with a check symbol on the screen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB7BA",
    d: "M94.3 113.6c0 3.5-2.9 6.4-6.4 6.4H6.4c-3.5 0-6.4-2.9-6.4-6.4V6.4C0 2.9 2.9 0 6.4 0h81.4c3.5 0 6.4 2.9 6.4 6.4v107.2h.1zm60-72.9c0-3.5-2.9-6.4-6.4-6.4h-38.6c-3.5 0-6.4 2.9-6.4 6.4v72.9c0 3.5 2.9 6.4 6.4 6.4h38.6c3.5 0 6.4-2.9 6.4-6.4V40.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M85.7 8.6H8.6v94.3h77.1V8.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M87.3 104.5H7V7h80.4l-.1 97.5zm-77.1-3.3h73.9v-91H10.2v91zm135.5-58.3h-34.3v60h34.3v-60z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M147.3 104.5h-37.5V41.2h37.5v63.3zm-34.3-3.3h31.1V44.5H113v56.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#047BB7",
    d: "M141.1 76.1c0 7.1-5.8 12.8-12.9 12.8s-12.9-5.8-12.9-12.8 5.8-12.8 12.9-12.8c7.2-.1 12.9 5.7 12.9 12.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M123.1 78l4.1 3.6 6.2-9.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.1 115.7c2.4 0 4.3-1.9 4.3-4.3s-1.9-4.3-4.3-4.3-4.3 1.9-4.3 4.3 2 4.3 4.3 4.3zm81.5 0c2.4 0 4.3-1.9 4.3-4.3s-1.9-4.3-4.3-4.3-4.3 1.9-4.3 4.3 1.9 4.3 4.3 4.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EE684D",
    d: "M32.1 70.2h30c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-30c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46 57.2c-3.1-.3-5.3-1.4-6.9-3l2.3-3.2c1.2 1.3 2.9 2.2 4.7 2.5v-4.6c-3-.8-6.3-1.9-6.3-5.8 0-3 2.3-5.5 6.3-5.9v-2.7h2.8v2.8c2.4.3 4.4 1.2 5.9 2.6l-2.3 3c-1.1-1-2.3-1.6-3.6-1.9v4.1c3 .8 6.4 1.9 6.4 5.9 0 3.2-2.1 5.7-6.4 6.2v2.7H46v-2.7zm0-12.8v-3.6c-1.3.2-2 .9-2 1.9 0 .8.8 1.3 2 1.7zm2.8 5.2v3.9c1.4-.3 2.2-1.1 2.2-2 0-1-.9-1.5-2.2-1.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#555D5F",
    d: "M137.1 49.8H120V53h17.1v-3.2zM60 77.7H25.7v3.2H60v-3.2zm-17.1 9.6H25.7v3.2h17.1l.1-3.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageFeatureInventory);
export default __webpack_public_path__ + "static/media/homepage-feature-inventory.63d2fa7165811334b4fb7fd9296c13d0.svg";
export { ForwardRef as ReactComponent };